// Route path constants for better maintainability
export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',

  // Protected routes
  HOME: '/',
  REPORTS: '/reports',
  APPOINTMENTS: '/appointments',
  LEADS: '/leads',
  PATIENTS: '/patients',
  PATIENT_DETAILS: '/patients/:id',
  OFFERINGS: '/offerings',
  BRANCHES: '/branches',
  USERS: '/users',
  ORGANIZATIONS: '/organizations',
  SETTINGS: '/settings',
  MEDICAL: '/medical',
  INSIDE_STOCK: '/inside-stock',
  TRANSACTIONS: '/transactions',
  PAYMENTS: '/payments',
  TASKS: '/tasks',
} as const;

// Route groups for better organization
export const PUBLIC_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.REGISTER,
  ROUTES.FORGOT_PASSWORD,
] as const;

export const PROTECTED_ROUTES = [
  ROUTES.HOME,
  ROUTES.REPORTS,
  ROUTES.APPOINTMENTS,
  ROUTES.LEADS,
  ROUTES.PATIENTS,
  ROUTES.PATIENT_DETAILS,
  ROUTES.OFFERINGS,
  ROUTES.BRANCHES,
  ROUTES.USERS,
  ROUTES.ORGANIZATIONS,
  ROUTES.SETTINGS,
  ROUTES.MEDICAL,
  ROUTES.INSIDE_STOCK,
  ROUTES.TRANSACTIONS,
  ROUTES.PAYMENTS,
  ROUTES.TASKS,
] as const;

// Resource configuration for Refine
export const RESOURCES = [
  {
    name: 'appointments',
    list: ROUTES.APPOINTMENTS,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'leads',
    list: ROUTES.LEADS,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'patients',
    list: ROUTES.PATIENTS,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'offerings',
    list: ROUTES.OFFERINGS,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'branches',
    list: ROUTES.BRANCHES,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'users',
    list: ROUTES.USERS,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'organizations',
    list: ROUTES.ORGANIZATIONS,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'medical',
    list: ROUTES.MEDICAL,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'inside_stock',
    list: ROUTES.INSIDE_STOCK,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'tasks',
    list: ROUTES.TASKS,
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'payments',
    list: ROUTES.PAYMENTS,
    meta: {
      canDelete: true,
    },
  },
] as const;
